import { IconFormNames, LifeArea, LocalizedLifeArea } from '@griply/types';

import { DocumentSnapshot } from '../types/firestore';
import { stripUndefined } from '../utils/strip-undefined';
import { coerceRoadmapViewSettings } from './coerce-roadmap-view-settings';
import {
  coerceGoalFilterDocument,
  coerceGoalSortingMode,
} from './filter-document';
import { firebaseObjectTimestampToDate } from './firebase-timestamp-to-date';

export const lifeAreaConverter = {
  fromFirestore: (snapshot: DocumentSnapshot): LifeArea | LocalizedLifeArea => {
    const data = firebaseObjectTimestampToDate(snapshot.data()) as Record<
      string,
      unknown
    >;
    data.id = snapshot.id;
    // Absent optional fields stay absent: an `undefined` value would fail any write that spreads the entity.
    return stripUndefined({
      ...data,
      name:
        typeof data.name === 'string'
          ? (data.name as string).trim()
          : data.name,
      iconName: Object.values(IconFormNames).includes(
        data.iconName as IconFormNames,
      )
        ? data.iconName
        : IconFormNames.PlaceholderIcon,
      visionPreview: data.visionPreview ?? null,
      // Anything non-boolean reads as absent, so the section defaults to visible.
      showVision:
        typeof data.showVision === 'boolean' ? data.showVision : undefined,
      roadmap: coerceRoadmapViewSettings(data.roadmap),
      goalSortingMode: coerceGoalSortingMode(data.goalSortingMode),
      goalFilterDocument:
        data.goalFilterDocument === undefined
          ? undefined
          : coerceGoalFilterDocument(data.goalFilterDocument) ?? null,
      projectFilterDocument:
        data.projectFilterDocument === undefined
          ? undefined
          : coerceGoalFilterDocument(data.projectFilterDocument) ?? null,
    } as LifeArea | LocalizedLifeArea);
  },
  toFirestore: (lifeArea: LifeArea | LocalizedLifeArea) => lifeArea,
};
